(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-elance"] && !Shopify.designMode) return;
  try {
    

  (function () {

    document.querySelectorAll('[data-elance-product]').forEach(function (root) {

      const track = root.querySelector('[data-gallery-track]');

      const viewport = root.querySelector('[data-gallery-viewport]');

      const slides = root.querySelectorAll('.elance-product__slide');

      const thumbs = root.querySelectorAll('[data-thumb-index]');

      const dots = root.querySelectorAll('[data-dot-index]');

      const prevBtn = root.querySelector('[data-gallery-prev]');

      const nextBtn = root.querySelector('[data-gallery-next]');

      const total = slides.length;

      let current = 0;



      function goTo(index) {

        if (index < 0) index = 0;

        if (index > total - 1) index = total - 1;

        current = index;

        if (track) track.style.transform = 'translateX(-' + (index * 100) + '%)';

        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));

        dots.forEach((d, i) => d.classList.toggle('is-active', i === index));

      }



      function goToMediaId(mediaId) {

        if (!mediaId) return;

        for (let i = 0; i < slides.length; i++) {

          if (String(slides[i].dataset.mediaId) === String(mediaId)) {

            goTo(i);

            return;

          }

        }

      }



      thumbs.forEach(t => t.addEventListener('click', () => goTo(parseInt(t.dataset.thumbIndex, 10))));

      dots.forEach(d => d.addEventListener('click', () => goTo(parseInt(d.dataset.dotIndex, 10))));

      if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));

      if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));



      root.addEventListener('keydown', (e) => {

        if (e.key === 'ArrowLeft') goTo(current - 1);

        if (e.key === 'ArrowRight') goTo(current + 1);

      });



      // Touch swipe

      if (viewport && track && total > 1) {

        let startX = 0, startY = 0, deltaX = 0, dragging = false, horizontalLocked = null;

        const width = () => viewport.offsetWidth;

        function getX(e) { return e.touches ? e.touches[0].clientX : e.clientX; }

        function getY(e) { return e.touches ? e.touches[0].clientY : e.clientY; }



        function onStart(e) {

          dragging = true; horizontalLocked = null;

          startX = getX(e); startY = getY(e); deltaX = 0;

          track.classList.add('is-dragging');

        }

        function onMove(e) {

          if (!dragging) return;

          const dx = getX(e) - startX;

          const dy = getY(e) - startY;

          if (horizontalLocked === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {

            horizontalLocked = Math.abs(dx) > Math.abs(dy);

          }

          if (horizontalLocked !== true) return;

          deltaX = dx;

          const pct = -(current * 100) + (dx / width()) * 100;

          track.style.transform = 'translateX(' + pct + '%)';

        }

        function onEnd() {

          if (!dragging) return;

          dragging = false;

          track.classList.remove('is-dragging');

          if (horizontalLocked === true) {

            const threshold = width() * 0.15;

            if (deltaX < -threshold && current < total - 1) goTo(current + 1);

            else if (deltaX > threshold && current > 0) goTo(current - 1);

            else goTo(current);

          } else {

            goTo(current);

          }

          deltaX = 0; horizontalLocked = null;

        }



        viewport.addEventListener('touchstart', onStart, { passive: true });

        viewport.addEventListener('touchmove', onMove, { passive: true });

        viewport.addEventListener('touchend', onEnd);

        viewport.addEventListener('touchcancel', onEnd);

      }



      // ============ VARIANTS ============

      const variantsScript = root.querySelector('[data-variants-json]');

      const variants = variantsScript ? JSON.parse(variantsScript.textContent) : null;

      const cartBtn = root.querySelector('[data-add-to-cart]');

      const cartLabel = cartBtn ? cartBtn.querySelector('[data-label]') : null;

      const priceEl = root.querySelector('[data-price]');



      let currentSelection = [];



      function findVariant(options) {

        return variants.find(v => v.options.every((opt, i) => opt === options[i]));

      }



      function updatePrice(variant) {

        if (!priceEl) return;

        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

        if (onSale) {

          priceEl.innerHTML =

            '<span class="elance-product__price-compare" data-price-compare>' + variant.compare_at_price_formatted + '</span>' +

            '<span class="elance-product__price-current elance-product__price-current--sale" data-price-current>' + variant.price_formatted + '</span>';

        } else {

          priceEl.innerHTML = '<span class="elance-product__price-current" data-price-current>' + variant.price_formatted + '</span>';

        }

      }



      function updateCartButton(variant) {

        if (!cartBtn) return;

        if (!variant) {

          cartBtn.disabled = true;

          cartBtn.setAttribute('aria-disabled', 'true');

          if (cartLabel) cartLabel.textContent = 'Unavailable';

          return;

        }

        cartBtn.dataset.variantId = variant.id;

        if (variant.available) {

          cartBtn.disabled = false;

          cartBtn.removeAttribute('aria-disabled');

          if (cartLabel) cartLabel.textContent = 'Add to cart';

        } else {

          cartBtn.disabled = true;

          cartBtn.setAttribute('aria-disabled', 'true');

          if (cartLabel) cartLabel.textContent = 'Sold out';

        }

      }



      function updateAvailability() {

        if (!variants) return;

        const groups = root.querySelectorAll('[data-option-group]');

        groups.forEach(group => {

          const idx = parseInt(group.dataset.optionGroup, 10);

          const opts = group.querySelectorAll('[data-option-value]');

          opts.forEach(opt => {

            const testSelection = currentSelection.slice();

            testSelection[idx] = opt.dataset.optionValue;

            const match = variants.find(v => {

              return testSelection.every((val, i) => val == null || v.options[i] === val);

            });

            opt.classList.toggle('is-unavailable', !match || !match.available);

          });

        });

      }



      function updateSelectedLabels() {

        currentSelection.forEach((val, i) => {

          const label = root.querySelector('[data-selected-value="' + i + '"]');

          if (label) label.textContent = val;

        });

      }



      function selectOption(groupIdx, value) {

        currentSelection[groupIdx] = value;



        // Toggle .is-selected on buttons in this group

        const group = root.querySelector('[data-option-group="' + groupIdx + '"]');

        if (group) {

          group.querySelectorAll('[data-option-value]').forEach(btn => {

            btn.classList.toggle('is-selected', btn.dataset.optionValue === value);

          });

        }



        updateSelectedLabels();



        const variant = findVariant(currentSelection);

        updateCartButton(variant);

        if (variant) {

          updatePrice(variant);

          if (variant.featured_media_id) goToMediaId(variant.featured_media_id);



          // Update URL with ?variant= without reloading

          if (window.history && window.history.replaceState) {

            const url = new URL(window.location);

            url.searchParams.set('variant', variant.id);

            window.history.replaceState({}, '', url);

          }

        }

        updateAvailability();

      }



      if (variants) {

        // Initialize current selection from selected buttons

        const groups = root.querySelectorAll('[data-option-group]');

        groups.forEach(group => {

          const idx = parseInt(group.dataset.optionGroup, 10);

          const selected = group.querySelector('[data-option-value].is-selected');

          currentSelection[idx] = selected ? selected.dataset.optionValue : null;

        });



        groups.forEach(group => {

          const idx = parseInt(group.dataset.optionGroup, 10);

          group.querySelectorAll('[data-option-value]').forEach(btn => {

            btn.addEventListener('click', () => {

              selectOption(idx, btn.dataset.optionValue);

            });

          });

        });



        updateAvailability();

      }



      // Toast helper

      const toast = root.querySelector('[data-toast]');

      let toastTimer = null;

      function showToast(message) {

        if (!toast) return;

        toast.textContent = message;

        toast.classList.add('is-visible');

        clearTimeout(toastTimer);

        toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2200);

      }



      // Add to cart (AJAX)

      if (cartBtn) {

        cartBtn.addEventListener('click', async () => {

          if (cartBtn.disabled) return;

          const variantId = cartBtn.dataset.variantId;

          const label = cartBtn.querySelector('[data-label]');

          const originalLabel = label.textContent;

          cartBtn.disabled = true;



          try {

            const res = await fetch('/cart/add.js', {

              method: 'POST',

              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },

              body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })

            });

            if (!res.ok) throw new Error('add failed');



            cartBtn.classList.add('is-added');

            label.textContent = 'Added';

            document.dispatchEvent(new CustomEvent('cart:refresh'));

            document.dispatchEvent(new CustomEvent('cart:updated'));



            setTimeout(() => {

              cartBtn.classList.remove('is-added');

              label.textContent = originalLabel;

              cartBtn.disabled = false;

            }, 2500);

          } catch (err) {

            label.textContent = 'Error';

            setTimeout(() => {

              label.textContent = originalLabel;

              cartBtn.disabled = false;

            }, 2000);

          }

        });

      }



      // Share

      const shareBtn = root.querySelector('[data-share-trigger]');

      if (shareBtn) {

        const shareLabel = shareBtn.querySelector('[data-share-label]');
        const shareUrl = root.dataset.productUrl || window.location.href;
        const shareTitle = root.dataset.productTitle || document.title;

        function setShareLabel(message) {
          if (!shareLabel) return;
          const original = 'Share';
          shareLabel.textContent = message;
          window.setTimeout(() => { shareLabel.textContent = original; }, 1600);
        }

        async function copyShareUrl() {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(shareUrl);
            return true;
          }

          const textarea = document.createElement('textarea');
          textarea.value = shareUrl;
          textarea.setAttribute('readonly', '');
          textarea.style.position = 'fixed';
          textarea.style.left = '-9999px';
          textarea.style.top = '0';
          document.body.appendChild(textarea);
          textarea.focus();
          textarea.select();

          let copied = false;
          try { copied = document.execCommand('copy'); } catch (e) { copied = false; }
          document.body.removeChild(textarea);
          return copied;
        }

        shareBtn.addEventListener('click', async () => {
          const shareData = { title: shareTitle, url: shareUrl };

          if (navigator.share) {
            try {
              await navigator.share(shareData);
              return;
            } catch (error) {
              if (error && error.name === 'AbortError') return;
            }
          }

          try {
            const copied = await copyShareUrl();
            if (copied) {
              setShareLabel('Copied');
              showToast('Link copied');
            } else {
              setShareLabel('Copy failed');
              showToast('Copy failed');
            }
          } catch (error) {
            setShareLabel('Copy failed');
            showToast('Copy failed');
          }
        });

      }


      // Accordion

      root.querySelectorAll('[data-accordion-trigger]').forEach(btn => {

        btn.addEventListener('click', () => {

          const acc = btn.closest('[data-accordion]');

          const open = acc.hasAttribute('data-open');

          if (open) {

            acc.removeAttribute('data-open');

            btn.setAttribute('aria-expanded', 'false');

          } else {

            acc.setAttribute('data-open', '');

            btn.setAttribute('aria-expanded', 'true');

          }

        });

      });

    });

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elance-product-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('elance-pdp')) return;
  class ElancePDP extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.form = this.querySelector('.ep-product-form');
      this.state = this.readState(this);
      this.gallery = this.querySelector('[data-ep-gallery]');
      this.slides = [...this.querySelectorAll('[data-media-id]')];
      this.index = Math.max(0, this.slides.findIndex(slide => !slide.hidden));
      this.addEventListener('click', event => this.onClick(event), { signal });
      this.addEventListener('change', event => this.onChange(event), { signal });
      this.addEventListener('submit', event => this.onSubmit(event), { signal });
      this.addEventListener('keydown', event => this.onKey(event), { signal });
      this.addEventListener('pointerdown', event => this.onPointerDown(event), { signal });
      this.addEventListener('pointermove', event => this.onPointerMove(event), { signal });
      this.addEventListener('pointerup', event => this.onPointerUp(event), { signal });
      this.addEventListener('pointercancel', () => this.cancelPointer(), { signal });
      document.addEventListener('shopify:block:select', event => {
        const block = this.querySelector(`[data-block-id="${CSS.escape(event.detail.blockId || '')}"]`);
        if (!block) return;
        const details = block.querySelector('details');
        if (details) details.open = true;
      }, { signal });
      this.showMedia(this.index, false);
      this.viewerObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.loadModel(entry.target);
            this.viewerObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '150px' });
      this.querySelectorAll('[data-ep-model-stage]').forEach(stage => this.viewerObserver.observe(stage));
      this.normalizeQuantity();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.variantAbort?.abort();
      this.viewerObserver?.disconnect();
      clearTimeout(this.toastTimer);
      clearTimeout(this.addTimer);
    }
    readState(scope) {
      try { return JSON.parse(scope.querySelector('[data-ep-state]')?.textContent || '{}'); }
      catch { return {}; }
    }
    root(path) {
      return (this.dataset.rootUrl || '/').replace(/\/?$/, '/') + path;
    }
    showMedia(index, scrollThumb = true) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      const active = this.slides[this.index];
      this.slides.forEach(slide => {
        const visible = slide === active;
        slide.hidden = !visible;
        if (visible) {
          const template = slide.querySelector('[data-ep-media-template]');
          if (template) template.replaceWith(template.content.cloneNode(true));
          if (slide.dataset.mediaType === 'model') this.setupModel(slide);
        } else {
          slide.querySelectorAll('video').forEach(video => video.pause());
          slide.querySelectorAll('model-viewer').forEach(model => { model.pause?.(); model.elancePlayer?.pause(); });
          slide.querySelectorAll('iframe').forEach(iframe => {
            try {
              iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }), '*');
              iframe.contentWindow?.postMessage(JSON.stringify({ method: 'pause' }), '*');
            } catch {}
          });
        }
      });
      this.querySelectorAll('[data-ep-thumb]').forEach(thumb => {
        const selected = thumb.dataset.epThumb === active.dataset.mediaId;
        thumb.classList.toggle('active', selected);
        thumb.setAttribute('aria-pressed', String(selected));
        if (selected && scrollThumb) {
          const strip = thumb.parentElement;
          if (strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: thumb.offsetLeft - strip.offsetLeft - (strip.clientWidth - thumb.clientWidth) / 2, behavior: this.motion() });
        }
      });
      const counter = this.querySelector('[data-ep-counter]');
      if (counter) counter.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    motion() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
    onClick(event) {
      if (event.target.matches('dialog')) {
        const dialog = event.target;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
      const target = event.target.closest('button,a');
      if (!target || !this.contains(target)) return;
      if (target.hasAttribute('data-ep-prev')) this.showMedia(this.index - 1);
      if (target.hasAttribute('data-ep-next')) this.showMedia(this.index + 1);
      if (target.hasAttribute('data-ep-thumb')) this.showMedia(this.slides.findIndex(slide => slide.dataset.mediaId === target.dataset.epThumb));
      if (target.hasAttribute('data-ep-share')) this.share();
      if (target.hasAttribute('data-ep-whatsapp')) {
        const url = new URL(target.href);
        const productUrl = new URL(this.dataset.productUrl, location.origin);
        if (this.state.id) productUrl.searchParams.set('variant', this.state.id);
        const selection = this.state.title && this.state.title !== 'Default Title' ? ` — ${this.state.title}` : '';
        url.searchParams.set('text', `${target.dataset.message} ${this.dataset.productTitle}${selection} ${productUrl.href}`);
        target.href = url.href;
      }
      if (target.hasAttribute('data-ep-jump')) this.querySelector('[data-ep-viewer-block]')?.scrollIntoView({ behavior: this.motion(), block: 'start' });
      if (target.dataset.epOpen) {
        const dialog = document.getElementById(target.dataset.epOpen);
        if (dialog && this.contains(dialog)) {
          dialog.querySelectorAll('[data-ep-dialog-template]').forEach(template => template.replaceWith(template.content.cloneNode(true)));
          dialog.showModal();
        }
      }
      if (target.hasAttribute('data-ep-close')) target.closest('dialog')?.close();
      if (target.hasAttribute('data-ep-quantity')) {
        const input = this.querySelector('input[type="number"][name="quantity"]');
        if (input) {
          if (target.dataset.epQuantity === 'up') input.stepUp(); else input.stepDown();
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      if (target.hasAttribute('data-ep-load-model')) this.loadModel(target.closest('[data-ep-model-stage]'));
    }
    onChange(event) {
      if (event.target.matches('[data-option-value-id]')) this.updateVariant(event.target);
      if (event.target.matches('[name="quantity"]')) this.normalizeQuantity();
    }
    async updateVariant(input) {
      this.variantAbort?.abort();
      this.variantAbort = new AbortController();
      const signal = this.variantAbort.signal;
      const selectedIds = [...this.querySelectorAll('[data-option-value-id]:checked')].map(el => el.dataset.optionValueId);
      const url = new URL(input.dataset.optionProductUrl || this.dataset.productUrl, location.origin);
      const currentParams = new URL(location.href).searchParams;
      if (currentParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', currentParams.get('preview_theme_id'));
      url.searchParams.set('option_values', selectedIds.join(','));
      if (url.pathname !== new URL(this.dataset.productUrl, location.origin).pathname) {
        location.assign(url.href);
        return;
      }
      url.searchParams.set('section_id', this.dataset.sectionId);
      const focusId = input.id;
      const quantity = this.form.querySelector('[name="quantity"]')?.value;
      this.updating = true;
      this.variantFailed = false;
      this.setBusy(true);
      this.querySelectorAll('[data-ep-update]').forEach(el => el.setAttribute('aria-busy', 'true'));
      try {
        const response = await fetch(url, { signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error(this.dataset.variantError);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (signal.aborted) return;
        const next = html.getElementById(this.id);
        if (!next) throw new Error(this.dataset.variantError);
        const state = this.readState(next);
        if (!Object.prototype.hasOwnProperty.call(state, 'available')) throw new Error(this.dataset.variantError);
        this.querySelectorAll('[data-ep-update]').forEach(current => {
          const replacement = next.querySelector(`[data-block-id="${CSS.escape(current.dataset.blockId)}"]`);
          if (replacement) current.replaceWith(replacement);
        });
        const idField = this.form.querySelector('[name="id"]');
        idField.value = state.id || '';
        idField.disabled = !state.id;
        this.state = state;
        this.querySelector('[data-ep-state]').textContent = JSON.stringify(state);
        const qty = this.form.querySelector('[name="quantity"]');
        if (qty) {
          qty.min = String(state.quantityMin || 1);
          qty.step = String(state.quantityStep || 1);
          if (state.quantityMax != null) qty.max = String(state.quantityMax); else qty.removeAttribute('max');
          qty.value = quantity || String(state.quantityMin || 1);
        }
        this.normalizeQuantity();
        if (state.mediaId) {
          const index = this.slides.findIndex(slide => slide.dataset.mediaId === String(state.mediaId));
          if (index >= 0) this.showMedia(index);
        }
        const browserUrl = new URL(location.href);
        browserUrl.searchParams.delete('option_values');
        if (state.id) browserUrl.searchParams.set('variant', state.id);
        else {
          browserUrl.searchParams.delete('variant');
          browserUrl.searchParams.set('option_values', selectedIds.join(','));
        }
        history.replaceState({}, '', browserUrl);
        const focusInput = document.getElementById(focusId);
        focusInput?.focus({ preventScroll: true });
        this.dispatchEvent(new CustomEvent('elance:variant-change', { bubbles: true, detail: { variant: state } }));
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.showError(this.dataset.variantError);
          this.toast(this.dataset.variantError);
          this.variantFailed = true;
        }
      } finally {
        if (!signal.aborted) {
          this.updating = false;
          this.querySelectorAll('[data-ep-update]').forEach(el => el.removeAttribute('aria-busy'));
          this.setBusy(false);
        }
      }
    }
    normalizeQuantity() {
      const input = this.form?.querySelector('[name="quantity"]');
      if (!input) return;
      const min = Number(input.min || this.state.quantityMin || 1);
      const step = Number(input.step || this.state.quantityStep || 1);
      const max = Number(input.max || this.state.quantityMax || Infinity);
      let value = Math.max(min, Number(input.value) || min);
      value = min + Math.round((value - min) / step) * step;
      if (Number.isFinite(max)) value = Math.min(value, min + Math.floor((max - min) / step) * step);
      input.value = String(Math.max(min, value));
    }
    setBusy(busy) {
      this.querySelectorAll('[data-ep-buy],[data-ep-add]').forEach(button => {
        button.disabled = busy || !this.state.available;
        if (busy) button.setAttribute('aria-busy', 'true'); else button.removeAttribute('aria-busy');
      });
    }
    showError(message = '') {
      const el = this.querySelector('[data-ep-error]');
      if (el) { el.textContent = message; el.hidden = !message; }
    }
    async onSubmit(event) {
      if (event.target !== this.form || event.defaultPrevented) return;
      event.preventDefault();
      if (this.submitting || this.updating || !this.state.available) return;
      if (this.variantFailed) { this.showError(this.dataset.variantError); return; }
      if (!this.form.checkValidity()) { this.form.reportValidity(); return; }
      const checkout = event.submitter?.hasAttribute('data-ep-buy');
      this.normalizeQuantity();
      this.showError();
      this.submitting = true;
      this.setBusy(true);
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
      const formData = new FormData(this.form);
      formData.delete('return_to');
      if (sections.length) formData.set('sections', [...new Set(sections)].slice(0, 5).join(','));
      formData.set('sections_url', location.pathname);
      try {
        const response = await fetch(this.root('cart/add.js'), { method: 'POST', body: formData, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.cartError);
        if (checkout) { location.assign(this.root('checkout')); return; }
        this.toast(this.dataset.addedLabel);
        const label = this.querySelector('[data-ep-add-label]');
        if (label) {
          const original = label.textContent;
          label.textContent = this.dataset.addedLabel;
          clearTimeout(this.addTimer);
          this.addTimer = setTimeout(() => { if (label.isConnected) label.textContent = original; }, 2000);
        }
        if (this.dataset.cartAction === 'page') { location.assign(this.dataset.cartUrl); return; }
        try {
          const cartResponse = await fetch(this.root('cart.js'), { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error();
          const cart = await cartResponse.json();
          cart.sections = result.sections || {};
          this.form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: result.items || [result], cart } }));
          if (sections.length && sections.every(id => cart.sections[id])) {
            const onSuccessDo = this.dataset.cartAction === 'drawer' ? 'force_open_drawer' : undefined;
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: this.dataset.cartAction === 'stay' ? 'elance:add' : 'variant:add', onSuccessDo, cart } }));
          } else {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            if (this.dataset.cartAction === 'drawer') {
              const drawer = document.querySelector('cart-drawer');
              if (drawer?.show) drawer.show(); else location.assign(this.dataset.cartUrl);
            }
          }
        } catch {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      } catch (error) {
        this.showError(error.message || this.dataset.cartError);
      } finally {
        this.submitting = false;
        this.setBusy(false);
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      }
    }
    async share() {
      const url = new URL(this.dataset.productUrl, location.origin);
      if (this.state.id) url.searchParams.set('variant', this.state.id);
      if (navigator.share) {
        try { await navigator.share({ title: this.dataset.productTitle, url: url.href }); return; }
        catch (error) { if (error.name === 'AbortError') return; }
      }
      try { await navigator.clipboard.writeText(url.href); this.toast(this.dataset.linkCopied); }
      catch {
        const dialog = this.querySelector('[data-ep-share-dialog]');
        const input = dialog.querySelector('[data-ep-share-url]');
        input.value = url.href;
        dialog.showModal();
        input.focus();
        input.select();
      }
    }
    toast(message) {
      const toast = this.querySelector('[data-ep-toast]');
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('show');
      clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => toast.classList.remove('show'), 2500);
    }
    onKey(event) {
      if (event.target.closest('[data-ep-spin]') && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
        event.preventDefault();
        this.spin(event.target.closest('[data-ep-spin]'), event.key === 'ArrowRight' ? 1 : -1);
      } else if (event.target.matches('[data-ep-swipe]') && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
        event.preventDefault();
        this.showMedia(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    }
    onPointerDown(event) {
      if (event.button !== 0 && event.pointerType === 'mouse') return;
      if (event.target.closest('button,a,input,model-viewer,video,iframe')) return;
      const spin = event.target.closest('[data-ep-spin]');
      const gallery = event.target.closest('[data-ep-swipe]');
      if (!spin && !gallery) return;
      if (gallery && this.slides[this.index]?.dataset.mediaType !== 'image') return;
      this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, lastX: event.clientX, target: spin || gallery, spin: !!spin };
      this.pointer.target.setPointerCapture?.(event.pointerId);
      this.pointer.target.classList.add('dragging');
    }
    onPointerMove(event) {
      const pointer = this.pointer;
      if (!pointer || pointer.id !== event.pointerId || !pointer.spin) return;
      const frames = this.frames(pointer.target);
      const threshold = Math.max(10, Math.min(55, pointer.target.clientWidth / Math.max(frames.length, 1)));
      const delta = event.clientX - pointer.lastX;
      if (Math.abs(delta) > threshold) {
        this.spin(pointer.target, delta > 0 ? -1 : 1);
        pointer.lastX = event.clientX;
      }
    }
    onPointerUp(event) {
      const pointer = this.pointer;
      if (!pointer || pointer.id !== event.pointerId) return;
      if (!pointer.spin) {
        const dx = event.clientX - pointer.x;
        const dy = event.clientY - pointer.y;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.25) this.showMedia(this.index + (dx < 0 ? 1 : -1));
      }
      this.cancelPointer();
    }
    cancelPointer() {
      if (this.pointer) {
        this.pointer.target.classList.remove('dragging');
        try { this.pointer.target.releasePointerCapture(this.pointer.id); } catch {}
      }
      this.pointer = null;
    }
    frames(stage) {
      try { return JSON.parse(stage.dataset.frames || '[]').filter(Boolean); }
      catch { return []; }
    }
    spin(stage, direction) {
      const frames = this.frames(stage);
      if (!frames.length) return;
      const next = ((Number(stage.dataset.index || 0) + direction) % frames.length + frames.length) % frames.length;
      stage.dataset.index = String(next);
      const img = stage.querySelector('[data-ep-spin-image]');
      if (img) img.src = frames[next];
      for (const offset of [-1, 1]) {
        const adjacent = new Image();
        adjacent.src = frames[(next + offset + frames.length) % frames.length];
      }
    }
    ensureModelViewer() {
      if (customElements.get('model-viewer')) return Promise.resolve();
      if (!window.Shopify?.loadFeatures) return Promise.resolve();
      if (!window.elanceModelViewerReady) {
        window.elanceModelViewerReady = new Promise((resolve, reject) => {
          window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: error => error ? reject(error) : resolve() }]);
        }).catch(error => { window.elanceModelViewerReady = null; throw error; });
      }
      return window.elanceModelViewerReady;
    }
    async setupModel(scope) {
      try {
        await this.ensureModelViewer();
        const model = scope.querySelector('model-viewer');
        if (!model || !model.isConnected) return;
        model.setAttribute('camera-controls', '');
        if (window.Shopify?.ModelViewerUI && !model.elancePlayer) {
          if (!document.querySelector('[data-elance-model-css]')) {
            const css = document.createElement('link');
            css.rel = 'stylesheet';
            css.href = 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css';
            css.dataset.elanceModelCss = '';
            document.head.append(css);
          }
          model.elancePlayer = new window.Shopify.ModelViewerUI(model, { focusOnPlay: true });
        }
        model.elancePlayer?.play();
      } catch {}
    }
    async loadModel(stage) {
      if (!stage || stage.dataset.loaded) return;
      stage.dataset.loaded = 'true';
      try {
        await this.ensureModelViewer();
        if (!stage.isConnected) return;
        const template = stage.querySelector('[data-ep-model-template]');
        if (!template) return;
        const fragment = template.content.cloneNode(true);
        stage.replaceChildren(fragment);
        await this.setupModel(stage);
      } catch { delete stage.dataset.loaded; }
    }
  }
  customElements.define('elance-pdp', ElancePDP);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      const track = root.querySelector('[data-track]');
      if (!track) return;
      const slides = Array.from(track.querySelectorAll('.gallery-slideshow__slide'));
      const total = slides.length;
      if (total < 2) {
        if (total === 1) slides[0].setAttribute('data-state', 'current');
        return;
      }

      const duration = parseInt(root.dataset.duration, 10) || 5000;
      let current = 0;
      let timer = null;
      let paused = false;

      function render() {
        slides.forEach((slide, i) => {
          let state = 'hidden';
          if (i === current) state = 'current';
          else if (i === (current + 1) % total) state = 'next';
          else if (i === (current - 1 + total) % total) state = 'prev';
          slide.setAttribute('data-state', state);
        });
      }

      function advance() {
        current = (current + 1) % total;
        render();
      }

      function start() {
        stop();
        timer = setInterval(() => { if (!paused) advance(); }, duration);
      }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      root.addEventListener('mouseenter', () => { paused = true; });
      root.addEventListener('mouseleave', () => { paused = false; });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop(); else start();
      });

      render();
      start();
    }

    document.querySelectorAll('.gallery-slideshow').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loading-screen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var loaders = document.querySelectorAll('.loading-screen[data-once-per-session]');
    loaders.forEach(function (loader) {
      var once = loader.dataset.oncePerSession === 'true';
      var key = 'ls-shown-' + loader.id;

      if (once && sessionStorage.getItem(key)) {
        loader.classList.add('is-removed');
        return;
      }

      var styles = getComputedStyle(loader);
      var duration = parseFloat(styles.getPropertyValue('--ls-duration')) || 4;
      var count = parseInt(styles.getPropertyValue('--ls-count'), 10) || 8;

      // Animation phase timing:
      //   flash cycle = count * 0.2s
      //   spread     = 1.4s
      //   minimum hold before exit = 0.4s
      var flashMs = count * 200;
      var spreadMs = 1400;
      var minRevealMs = flashMs + spreadMs + 400;
      var exitStartMs = Math.max(duration * 1000, minRevealMs);
      var fadeMs = 1200; // matches CSS transition duration

      document.documentElement.style.overflow = 'hidden';

      setTimeout(function () {
        loader.classList.add('is-hiding');
        document.documentElement.style.overflow = '';
      }, exitStartMs);

      setTimeout(function () {
        loader.classList.add('is-removed');
        if (once) sessionStorage.setItem(key, '1');
      }, exitStartMs + fadeMs + 50);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
